import React from 'react';
import { useNotifications } from '../hooks/useNotifications';
import { trackEvent } from '../services/analytics';

const NotificationTest = () => {
  const { isSubscribed, loading, subscribe, unsubscribe } = useNotifications();

  const testAnalytics = () => {
    trackEvent('test', 'button_click', 'test_analytics', 1);
    console.log('Analytics test event sent');
  };

  return (
    <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-lg my-8">
      <h2 className="text-2xl font-bold mb-4">Integration Test Panel</h2>
      
      {/* Status Display */}
      <div className="mb-4 p-4 bg-gray-100 rounded">
        <p className="font-medium">
          Notification Status: {loading ? 'Checking...' : (isSubscribed ? 'Subscribed' : 'Not Subscribed')}
        </p>
      </div>

      {/* Action Buttons */}
      <div className="space-y-4">
        <button
          onClick={subscribe}
          disabled={loading || isSubscribed}
          className={`w-full py-2 px-4 rounded-md text-white font-medium ${
            loading || isSubscribed
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-blue-600 hover:bg-blue-700'
          }`}
        >
          {loading ? 'Processing...' : 'Subscribe to Notifications'}
        </button>

        <button
          onClick={unsubscribe}
          disabled={loading || !isSubscribed}
          className={`w-full py-2 px-4 rounded-md text-white font-medium ${
            loading || !isSubscribed
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-red-600 hover:bg-red-700'
          }`}
        >
          {loading ? 'Processing...' : 'Unsubscribe from Notifications'}
        </button>

        <button
          onClick={testAnalytics}
          className="w-full py-2 px-4 rounded-md text-white font-medium bg-green-600 hover:bg-green-700"
        >
          Test Analytics
        </button>
      </div>

      {/* Debug Information */}
      <div className="mt-8 p-4 bg-gray-100 rounded text-sm">
        <h3 className="font-bold mb-2">Debug Information:</h3>
        <pre className="whitespace-pre-wrap">
          {JSON.stringify(
            {
              isSubscribed,
              loading,
              timestamp: new Date().toISOString(),
              userAgent: navigator.userAgent,
              url: window.location.href
            },
            null,
            2
          )}
        </pre>
      </div>

      {/* Testing Instructions */}
      <div className="mt-4 p-4 bg-yellow-50 rounded text-sm">
        <h3 className="font-bold mb-2">Testing Steps:</h3>
        <ol className="list-decimal pl-4 space-y-2">
          <li>Click "Test Analytics" to verify GA4 tracking</li>
          <li>Subscribe to notifications using the button above</li>
          <li>Check browser permissions are granted</li>
          <li>Verify in OneSignal dashboard</li>
          <li>Test unsubscribe functionality</li>
        </ol>
      </div>
    </div>
  );
};

export default NotificationTest; 